module.exports = __webpack_public_path__ + "img/GH-kyujin-top-028.3674365a.webp";